import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useContext, useState, useRef } from 'react';
import GlobalContext from '../../components/Context/GloablContext';
import BranchHoliday from './BranchHoliday';
import StudentHoliday from './StudentHoliday';
import EmployeeHoliday from './EmployeeHoliday';


const HolidayCalendar = ({ type }) => {
    
    const { isSideNavBar, setToastmessage, isInactiveBranch } = useContext(GlobalContext);
    const [recodes, setRecodes] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({ type: 'branchHoliday' });

    const handleNavigation = (type) => {
        if (type !== searchParams.get("type")) {
            setSearchParams({ type: type })
            setRecodes({})
        }
    }
    const tableContainerRef = useRef()

    return (
        <>
            <div
                className={`w-full main-screenInst overflow-x-hidden max-h-screen min-h-screen relative ${
                    !isSideNavBar ? 'w-[270px] ' : ''
                }`}
                ref={tableContainerRef}
            >
                <div className={`mainDataCntnr ${!isSideNavBar ? 'normal' : 'wide'}`}>
                    <div
                        className="mainDataCntnrTop shadow-s13"
                        style={{ position: 'sticky', WebkitPosition: 'sticky' }}
                    >
                        <div className="flex items-center">
                            <h5 className="pageHeader adderror">
                                Holiday Management
                            </h5>
                        </div>
                    </div>

                    <div className="pb-10 relative">
                        <ul
                            className="mr-4 ml-4 flex list-none flex-row flex-wrap border-b border-[#B3BBC1] pl-9 
                            pt-6 bg-[#fff] sticky top-[64px] left-0 -mx-1"
                            role="tablist"
                            data-te-nav-ref=""
                        >
                            <li role="presentation">
                                <p
                                    id="branchHoliday"
                                    onClick={() => handleNavigation('branchHoliday')}
                                    className={`${searchParams.get("type") === "branchHoliday" ? "selected" : ""} 
                                    tab-element mr-[126px]`}
                                >
                                    Branch
                                </p>
                            </li>
                            <li role="presentation">
                                <p
                                    id="studentHoliday"
                                    onClick={() => handleNavigation('studentHoliday')}
                                    className={`${searchParams.get('type') === 'studentHoliday' ? 'selected' : ''} 
                                    tab-element  mr-[126px] data-[te-nav-active]:font-semibold`}
                                >
                                    Students
                                </p>
                            </li>
                            <li role="presentation">
                                <p
                                    id="staffHoliday"
                                    onClick={() => handleNavigation('staffHoliday')}
                                    className={`${searchParams.get('type') === 'staffHoliday' ? 'selected' : ''} 
                                    tab-element data-[te-nav-active]:font-semibold`}
                                >
                                    Employees
                                </p>
                            </li>
                        </ul>

                        <div className="tabbedPgListDiv_holidays">
                            {searchParams.get("type") === "branchHoliday" && (
                                <BranchHoliday />
                            )}
                            {searchParams.get("type") === "studentHoliday" && (
                                <StudentHoliday />
                            )}
                            {searchParams.get("type") === "staffHoliday" && (
                                <EmployeeHoliday />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HolidayCalendar;
